/**
 * Streaming Limits Hook
 * Wrapper around StreamingLimitsContext
 */

import { useStreamingLimitsContext } from '../contexts/StreamingLimitsContext';

interface StreamingLimitsHook {
  remainingTime: number;
  isUnlimited: boolean;
  isLimitExceeded: boolean;
  isBlocked: boolean;
  isStreaming: boolean;
  startStreaming: () => void;
  stopStreaming: () => Promise<void>;
  refresh: () => Promise<void>;
  clearBlock: () => Promise<void>;
}

/**
 * Hook wrapper for StreamingLimitsContext
 */
export const useStreamingLimits = (): StreamingLimitsHook => {
  const context = useStreamingLimitsContext();
  
  return {
    remainingTime: context.state.remainingTime,
    isUnlimited: context.state.isUnlimited,
    isLimitExceeded: context.state.isLimitExceeded,
    isBlocked: context.state.isBlocked,
    isStreaming: context.state.isStreaming,
    startStreaming: context.startStreaming,
    stopStreaming: context.stopStreaming,
    refresh: context.refresh,
    clearBlock: context.clearBlock,
  };
};
